import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { trackPage } from "@/lib/activity";
import { MODULES } from "@/lib/modules";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { SidebarNav } from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname, search } = useLocation();
  useEffect(() => {
    const m = [...MODULES].sort((a, b) => b.path.length - a.path.length).find((x) => pathname.startsWith(x.path));
    trackPage(pathname + search, m ? (pathname === m.path ? m.label : `${m.label} · Detay`) : document.title);
  }, [pathname, search]);
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex w-[248px] shrink-0 sticky top-0 h-screen bg-slate-900" data-testid="sidebar">
        <SidebarNav />
      </aside>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-[260px] bg-slate-900 border-slate-800" data-testid="sidebar-mobile">
          <SheetTitle className="sr-only">Menü</SheetTitle>
          <SidebarNav onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onMenu={() => setMobileOpen(true)} />
        <main className="flex-1 p-4 md:p-6 lg:p-8" data-testid="main-content">
          <ErrorBoundary resetKey={pathname}><Outlet /></ErrorBoundary>
        </main>
        <footer className="px-4 md:px-6 lg:px-8 pb-3 text-[11px] text-slate-400" data-testid="activity-footer-note">Kullanıcı hareketleri güvenlik ve denetim amacıyla kaydedilir.</footer>
      </div>
    </div>
  );
}
